import { getDocument } from './getDocument.js';

function hasFocusWithin(element) {
  var document = getDocument(element);
  if (!document.activeElement) return false;
  return element.contains(document.activeElement);
}

export { hasFocusWithin };